import moment from 'moment';
import { CLMessageTypeEnum } from 'pages/Admin/CL/enum';

// CL Admin page chart date handler
export const handleDate = (selectFilter: number) => {
    let date = '';
    let startDate = '';
    let endDate = '';

    switch (selectFilter) {
        case 0:
            date = `${moment()
                .subtract(7 - 1, 'day')
                .format('YY.MM.DD(ddd)')} ~ ${moment().format('YY.MM.DD(ddd)')}`;
            startDate = moment()
                .subtract(7 - 1, 'day')
                .format('YYYY-MM-DD');
            endDate = moment().format('YYYY-MM-DD');
            break;
        case 1:
            date = `${moment()
                .subtract(14 - 1, 'day')
                .format('YY.MM.DD(ddd)')} ~ ${moment().format('YY.MM.DD(ddd)')}`;
            startDate = moment()
                .subtract(14 - 1, 'day')
                .format('YYYY-MM-DD');
            endDate = moment().format('YYYY-MM-DD');
            break;
        case 2:
            date = `${moment()
                .subtract(21 - 1, 'day')
                .format('YY.MM.DD(ddd)')} ~ ${moment().format('YY.MM.DD(ddd)')}`;
            startDate = moment()
                .subtract(21 - 1, 'day')
                .format('YYYY-MM-DD');
            endDate = moment().format('YYYY-MM-DD');
            break;
        case 3:
            date = `${moment()
                .subtract(30 - 1, 'day')
                .format('YY.MM.DD(ddd)')} ~ ${moment().format('YY.MM.DD(ddd)')}`;
            startDate = moment()
                .subtract(30 - 1, 'day')
                .format('YYYY-MM-DD');
            endDate = moment().format('YYYY-MM-DD');
            break;
        case 4:
            date = `${moment()
                .subtract(90 - 1, 'day')
                .format('YY.MM.DD(ddd)')} ~ ${moment().format('YY.MM.DD(ddd)')}`;
            startDate = moment()
                .subtract(90 - 1, 'day')
                .format('YYYY-MM-DD');
            endDate = moment().format('YYYY-MM-DD');
            break;
        default:
            date = `${moment()
                .subtract(7 - 1, 'day')
                .format('YY.MM.DD(ddd)')} ~ ${moment().format('YY.MM.DD(ddd)')}`;
            startDate = moment()
                .subtract(7 - 1, 'day')
                .format('YYYY-MM-DD');
            endDate = moment().format('YYYY-MM-DD');
            break;
    }
    return { date, startDate, endDate };
};

// TODO: 해당 병원에 따른 병원명 수정
export const formatExampleMessage = (messageType: string, hospitalName: string) => {
    console.log(messageType, hospitalName, 'messageType, hospitalName');
    switch (messageType) {
        case CLMessageTypeEnum.MEDICAL_GUIDE:
            return `${hospitalName}에서 진료 안내드려요`;
        case CLMessageTypeEnum.CALORIE_MANAGEMENT:
        case CLMessageTypeEnum.ETC:
            return `${hospitalName}에서 전달드려요`;
        default:
            return `${hospitalName}에서 전달드려요`;
    }
};
export const formatUserSearchFilter = (searchField: string) => {
    switch (searchField) {
        case '전체':
            return '';
        case '이름':
            return 'name';
        case '연락처':
            return 'mobile';
        case '이메일':
            return 'email';
        default:
            return '';
    }
};
